import { useAnalytics } from "hooks/useAnalytics";
import { executeVSCodeCommand } from "utils/vscode";

import type { Command } from "../../types";

export const useOpenDocumentation = (): Command => {
  const track = useAnalytics();

  return {
    id: "codesandbox.documentation.open",
    section: "CodeSandbox",
    name: "Open Documentation",
    binding: "Ctrl+Alt+O",
    perform: () => {
      executeVSCodeCommand("codesandbox.openCsbTab", {
        type: "DOCS",
      });

      track("open_docs", { event_source: "command_palette" });
    },
  };
};
